import { React, useState, useEffect } from "react";
import {
  Box,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  LinearProgress,
  TablePagination,
} from "@mui/material";
import { Helper } from "../../../tools/Helper";
import { api_Routes } from "../../../api_Routes";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";
import { showIconByServiceId } from "../../../helpers/showIconByServiceId";
import SwitchButton from "./switch-button";
import Row from "./OfferRow";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import {useCenteredSnackbar} from "../../../tools/useCenteredSnackbar";

const OrderHistory = () => {
  const navigate = useNavigate();
  const { enqueueSnackbar,closeSnackbar } = useSnackbar();
    const { showCenteredPopup } = useCenteredSnackbar();
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [filtersChanged, setFiltersChanged] = useState(false);
  const [data, setData] = useState([]);
  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

    const action = key => (
        <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={() => closeSnackbar(key)}
        >
            <CloseIcon fontSize="small" />
        </IconButton>
    );
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setCurrentPage(0);
  };
  const [option, setOption] = useState("service");
    const baseApi =
        option === "service"
            ? api_Routes.dashboard.orderhistory.view
            : option === "offer"
            ? api_Routes.dashboard.orderhistory.viewByOffer
            : api_Routes.dashboard.orderhistory.viewByDomain;
  const [history, setHistory] = useState([]);
  const [pageloading, setPageLoading] = useState(true); // State for loading
  const [selectedFilter, setSelectedFilter] = useState("all");
  const calculateDiscount = (discount, discount_type, price) => {
    const numDiscount = Number(discount) || 0;
    const numPrice = Number(price) || 0;
    switch (discount_type) {
      case "const":
        return numDiscount.toFixed(2);
      case "percentage":
        return ((numPrice * numDiscount) / 100).toFixed(2);
      default:
        return "0.00";
    }
  };
  useEffect(() => {
    Order_History();
  }, [selectedFilter, option]);

  const Order_History = async () => {
    setPageLoading(true); // Show loader
    setPageLoading(true);
    let url = `${baseApi}?per_page=${rowsPerPage}&page=${currentPage + 1}`;

    if (selectedFilter !== "all") {
      url += `&status=${selectedFilter}`;
    }

    const { response } = await Helper.Get({
      url,
      hasToken: true,
    });

    if (response) {
      setData(response);
      setHistory(
        response.data.map((history) => ({
          request_id: history.request_id,
          uuid: history.uuid,
          panel_url: history.panel_url,
          title: history.title,
          description: history.description,
          status: history.status,
          status_payment: history.status_payment,
          panelName: history.panelName,
          userName: history.userName,
          ourServiceName: history.ourServiceName,
          ourServiceNameId: history.ourServiceNameId,
          ourServiceTypeId: history.ourServiceTypeId,
          report: history.report,
          price: history.price,
          count: history.count,
          discount: history.discount,
          discount_type: history.discount_type,
          domain: history.domain,
            payment_method: history.payment_method,
        }))
      );
    } else {
    }
    setPageLoading(false); // Hide loader
  };

  const handleFilterChange = (filter) => {
    setSelectedFilter(filter);
    setCurrentPage(0);
    setFiltersChanged(true);
  };

  const handleDownload = async (report) => {
    try {
      const link = document.createElement("a");
      link.href = report;
      link.setAttribute("download", "image.jpg");
      link.setAttribute("target", "_blank");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
        showCenteredPopup(error || "Failed to download report",
            { variant: "error",
                persist: true });
      // enqueueSnackbar(error || "Failed to download report", {
      //   variant: "error",
      //     persist: true,
      //     action,
      // });
    }
  };
  useEffect(() => {
    if (filtersChanged) {
      setCurrentPage(0);
      setFiltersChanged(false);
    } else {
      Order_History();
    }
  }, [filtersChanged, currentPage, rowsPerPage, option]);
  return (
    <>
      <Box>
        <Typography
          sx={{
            color: "#474747",
            fontSize: "24px",
            lineHeight: "30px",
            fontWeight: "600",
          }}
        >
          Your Ads Subscriptions
        </Typography>
        <Box>
          <SwitchButton orderOption={option} setOrderOption={setOption} />
        </Box>
        <Box
          sx={{
            display: { sm: "flex", xs: "grid" },
            gridTemplateColumns: { sm: "auto", xs: "1fr 1fr" },
            flexDirection: "row",
            gap: "10px",
            marginTop: "20px",
          }}
        >
          {["all", "pending", "in_progress", "complete"].map((filter) => (
            <Button
              key={filter}
              variant={selectedFilter === filter ? "contained" : "outlined"}
              sx={{
                "&:hover": {
                  backgroundColor: "#3F78E0",
                  color: "white",
                },
                borderRadius: "5px",
                border: "2px solid #3F78E0",
                color: selectedFilter === filter ? "white" : "#303030",
                fontSize: "14px",
                fontWeight: "600",
                paddingBlock: "10px",
                lineHeight: "18px",
                width: { sm: "130px", xs: "100%" },
                backgroundColor:
                  selectedFilter === filter ? "#3F78E0" : "white",
              }}
              onClick={() => handleFilterChange(filter)}
            >
              {filter.replace("_", " ")}
            </Button>
          ))}
        </Box>

        {/* Show loader when pageloading is true */}
        {pageloading && (
          <Box sx={{ width: "100%", marginTop: "10px" }}>
            <LinearProgress />
          </Box>
        )}

        <TableContainer
          component={Paper}
          sx={{
            boxShadow: "none",
            border: "2px solid #3F78E0",
            marginTop: "20px",
          }}
        >
          {option === "service" && history?.length > 0 ? (
            <>
              <Table>
                <TableHead>
                  <TableRow
                    sx={{
                      backgroundColor: "#D1DDE4",
                    }}
                  >
                    <TableCell
                      sx={{
                        fontWeight: "bold",
                        color: "#333333",
                        textAlign: "center",
                        borderInlineEnd: "1px solid #3F78E0",
                      }}
                    >
                      ID
                    </TableCell>
                    <TableCell
                      sx={{
                        fontWeight: "bold",
                        color: "#333333",
                        textAlign: "center",
                        borderInlineEnd: "1px solid #3F78E0",
                      }}
                    >
                      Icon
                    </TableCell>
                    <TableCell
                      sx={{
                        fontWeight: "bold",
                        color: "#333333",
                        textAlign: "center",
                        borderInlineEnd: "1px solid #3F78E0",
                      }}
                    >
                      Service name
                    </TableCell>
                    <TableCell
                      sx={{
                        fontWeight: "bold",
                        color: "#333333",
                        textAlign: "center",
                        borderInlineEnd: "1px solid #3F78E0",
                      }}
                    >
                      Panel url
                    </TableCell>
                    <TableCell
                      sx={{
                        fontWeight: "bold",
                        color: "#333333",
                        textAlign: "center",
                        borderInlineEnd: "1px solid #3F78E0",
                      }}
                    >
                      Title
                    </TableCell>
                    <TableCell
                      sx={{
                        fontWeight: "bold",
                        color: "#333333",
                        textAlign: "center",
                        borderInlineEnd: "1px solid #3F78E0",
                      }}
                    >
                      Description
                    </TableCell>

                    <TableCell
                      sx={{
                        fontWeight: "bold",
                        color: "#333333",
                        textAlign: "center",
                        borderInlineEnd: "1px solid #3F78E0",
                      }}
                    >
                      Status
                    </TableCell>
                    <TableCell
                      sx={{
                        fontWeight: "bold",
                        color: "#333333",
                        textAlign: "center",
                        borderInlineEnd: "1px solid #3F78E0",
                      }}
                    >
                      Status payment
                    </TableCell>
                    <TableCell
                      sx={{
                        fontWeight: "bold",
                        color: "#333333",
                        textAlign: "center",
                        borderInlineEnd: "1px solid #3F78E0",
                      }}
                    >
                      Price
                    </TableCell>
                    <TableCell
                      sx={{
                        fontWeight: "bold",
                        color: "#333333",
                        textAlign: "center",
                        borderInlineEnd: "1px solid #3F78E0",
                      }}
                    >
                      Discount
                    </TableCell>
                    <TableCell
                      sx={{
                        fontWeight: "bold",
                        color: "#333333",
                        textAlign: "center",
                        borderInlineEnd: "1px solid #3F78E0",
                      }}
                    >
                      Action
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {history.map((row, index) => (
                    <TableRow
                      key={index}
                      sx={{
                        backgroundColor: "#E5EDFF",
                        borderBlock: "2px solid #3F78E0",
                      }}
                    >
                      <TableCell
                        sx={{
                          textAlign: "center",
                          color: "#333333",
                            border: "1px solid #3F78E0",
                        }}
                      >
                        {row.request_id}
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: "center",
                            border: "1px solid #3F78E0",
                          color: "#333333",
                        }}
                      >
                        <Box
                          className="icons"
                          sx={{
                            height: "40px",
                            display: "flex",
                            gap: "8px",
                            justifyContent: "center",
                            overflow: "hidden",
                            width: "100%",
                            paddingInline: "5px",
                          }}
                        >
                          {row?.ourServiceNameId ? (
                            <img
                              src={showIconByServiceId(row?.ourServiceNameId)}
                              alt="icon"
                              key={index}
                              style={{
                                height: "100%",
                                maxWidth: "50px",
                                objectFit: "contain",
                              }}
                            />
                          ) : (
                            "x"
                          )}
                        </Box>
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: "center",
                            border: "1px solid #3F78E0",
                          color: "#333333",
                        }}
                      >
                        {row.ourServiceName}
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: "center",
                            border: "1px solid #3F78E0",
                          color: "#333333",
                        }}
                      >
                        {row.panel_url}
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: "center",
                            border: "1px solid #3F78E0",
                          color: "#333333",
                        }}
                      >
                        {row.title}
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: "center",
                            border: "1px solid #3F78E0",
                          color: "#333333",
                        }}
                      >
                        {row.description}
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: "center",
                            border: "1px solid #3F78E0",
                          color: "#333333",
                        }}
                      >
                        {row.status}
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: "center",
                            border: "1px solid #3F78E0",
                          color: "#333333",
                        }}
                      >
                        {row.status_payment}
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: "center",
                            border: "1px solid #3F78E0",
                          color: "#333333",
                        }}
                      >
                        ${row.price}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          textAlign: "center",
                          color: "#333333",
                          border: "1px solid #3F78E0",
                        }}
                      >
                        $
                        {calculateDiscount(
                          row?.discount,
                          row?.discount_type,
                          row?.price
                        )}
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: "center",
                          color: "#333333",
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "center",
                          alignItems: "center",
                          gap: "10px",
                        }}
                      >
                        {(row?.ourServiceNameId === 1 ||
                          row?.ourServiceNameId === 10 ||
                          row?.ourServiceNameId === 11 ||
                          row?.ourServiceNameId === 9) &&
                        (row?.status === "in_progress" ||
                          row?.status === "complete") ? (
                          <Button
                            sx={{
                              background: "#ECA601",
                              boxShadow: `
                          0px 3px 3px #00000040, 
                          inset 0px 4px 7px #FFFFFF40
                        `,
                              color: "white",
                              borderRadius: "6px",
                              width: "85px",
                              fontSize: "12px",
                            }}
                            onClick={() =>
                              navigate(
                                `/dashboard/order-history/service-statistic/${row?.request_id}`
                              )
                            }
                          >
                            Statistics
                          </Button>
                        ) : (
                          row?.report && (
                            <Button
                              sx={{
                                backgroundColor: "#ECA601",
                                boxShadow: `
                         0px 3px 3px #00000040, 
                         inset 0px 4px 7px #FFFFFF40
                       `,
                                color: "white",
                                borderRadius: "6px",
                                width: "85px",
                                fontSize: "12px",
                              }}
                              onClick={() => handleDownload(row?.report)}
                            >
                              Report
                            </Button>
                          )
                        )}
                        {row.status_payment === "pending" &&
                          row.status !== "complete" && (
                            <Button
                              sx={{
                                backgroundColor: "#3F78E0",
                                color: "#fff",
                                boxShadow: `
                          0px 3px 3px #00000040, 
                          inset 0px 4px 7px #FFFFFF40
                        `,
                                borderRadius: "6px",
                                width: "85px",
                                fontSize: "12px",
                              }}
                              onClick={() => {
                                navigate(
                                  `/ServicesInvoice?invoice_id=${row.uuid}`
                                );
                              }}
                            >
                              Pay
                            </Button>
                          )}
                          {
                              (
                                  row?.ourServiceNameId !== 1 &&
                                  row?.ourServiceNameId !== 28 &&
                                  row?.ourServiceNameId !== 40 &&
                                  row?.ourServiceNameId !== 41 &&
                                  row?.ourServiceNameId !== 42 &&
                                  row?.ourServiceNameId !== 43 &&
                                  row?.ourServiceNameId !== 44 &&
                                  row?.ourServiceNameId !== 45 &&
                                  row?.ourServiceNameId !== 46 &&
                                  row?.status !== "complete"  &&
                                  <Button
                                      sx={{
                                          backgroundColor: "#3F78E0",
                                          color: "#fff",
                                          boxShadow: `
                          0px 3px 3px #00000040, 
                          inset 0px 4px 7px #FFFFFF40
                        `,
                                          borderRadius: "6px",
                                          width: "85px",
                                          fontSize: "12px",
                                      }}
                                      onClick={() => {
                                          navigate(
                                              `/dashboard/ServicesEdit/${row.uuid}`
                                          );
                                      }}
                                  >
                                      Edit
                                  </Button>
                              )
                          }

                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
              <div className="mt-4 flex justify-center items-center">
                <TablePagination
                  page={currentPage}
                  className="mt-auto"
                  onPageChange={handlePageChange}
                  count={data.pagination.total}
                  rowsPerPage={rowsPerPage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  variant="outlined"
                  shape="rounded"
                  rowsPerPageOptions={[ 25, 50,100]}
                />
              </div>
            </>
          ) : option === "offer" && history?.length > 0 ? (
            <>
              <Table>
                <TableHead>
                  <TableRow sx={{ backgroundColor: "#D1DDE4" }}>
                    <TableCell
                      sx={{
                        backgroundColor: "primary.main",
                        color: "white",
                        fontWeight: "bold",
                        textAlign: "center",
                        borderInlineEnd: "1px solid #3F78E0",
                      }}
                    />
                    {[
                      "Offer ID",
                      "Offer Name",
                      "User Name",
                      "Price",
                      "Discount",
                      "Panel URL",
                      "Payment Method",
                      "Created At",
                      "Status Payment",
                      "Status",
                      "Action",
                    ].map((label) => (
                      <TableCell
                        key={label}
                        sx={{
                          fontWeight: "bold",
                          color: "#333333",
                          textAlign: "center",
                          borderInlineEnd: "1px solid #3F78E0",
                        }}
                      >
                        {label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data.data.map((row) => (
                    <Row item={row} />
                  ))}
                </TableBody>
              </Table>
              <div className="mt-4 flex justify-center items-center">
                <TablePagination
                  page={currentPage}
                  className="mt-auto"
                  onPageChange={handlePageChange}
                  count={data.pagination.total}
                  rowsPerPage={rowsPerPage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  variant="outlined"
                  shape="rounded"
                  rowsPerPageOptions={[ 25, 50,100]}
                />
              </div>
            </>
          ) : option === "domain" && history?.length > 0 ? (
              <>
                  <Table>
                      <TableHead>
                          <TableRow
                              sx={{
                                  backgroundColor: "#D1DDE4",
                              }}
                          >
                              <TableCell
                                  sx={{
                                      fontWeight: "bold",
                                      color: "#333333",
                                      textAlign: "center",
                                      borderInlineEnd: "1px solid #3F78E0",
                                  }}
                              >
                                  ID
                              </TableCell>
                              <TableCell
                                  sx={{
                                      fontWeight: "bold",
                                      color: "#333333",
                                      textAlign: "center",
                                      borderInlineEnd: "1px solid #3F78E0",
                                  }}
                              >
                                  Domain
                              </TableCell>
                              <TableCell
                                  sx={{
                                      fontWeight: "bold",
                                      color: "#333333",
                                      textAlign: "center",
                                      borderInlineEnd: "1px solid #3F78E0",
                                  }}
                              >
                                  Payment method
                              </TableCell>
                              <TableCell
                                  sx={{
                                      fontWeight: "bold",
                                      color: "#333333",
                                      textAlign: "center",
                                      borderInlineEnd: "1px solid #3F78E0",
                                  }}
                              >
                                  Status payment
                              </TableCell>
                              <TableCell
                                  sx={{
                                      fontWeight: "bold",
                                      color: "#333333",
                                      textAlign: "center",
                                      borderInlineEnd: "1px solid #3F78E0",
                                  }}
                              >
                                  Price
                              </TableCell>
                              <TableCell
                                  sx={{
                                      fontWeight: "bold",
                                      color: "#333333",
                                      textAlign: "center",
                                      borderInlineEnd: "1px solid #3F78E0",
                                  }}
                              >
                                  Action
                              </TableCell>
                          </TableRow>
                      </TableHead>
                      <TableBody>
                          {history.map((row, index) => (
                              <TableRow
                                  key={index}
                                  sx={{
                                      backgroundColor: "#E5EDFF",
                                      borderBlock: "2px solid #3F78E0",
                                  }}
                              >
                                  <TableCell
                                      sx={{
                                          textAlign: "center",
                                          color: "#333333",
                                          borderInlineEnd: "1px solid #3F78E0",
                                      }}
                                  >
                                      {row.request_id}
                                  </TableCell>
                                  <TableCell
                                      sx={{
                                          textAlign: "center",
                                          borderInlineEnd: "1px solid #3F78E0",
                                          color: "#333333",
                                      }}
                                  >
                                      {row.domain}
                                  </TableCell>
                                  <TableCell
                                      sx={{
                                          textAlign: "center",
                                          borderInlineEnd: "1px solid #3F78E0",
                                          color: "#333333",
                                      }}
                                  >
                                      {row.payment_method === 'manually' ? 'Cash Payment (via Marketer)' : row.payment_method}
                                  </TableCell>
                                  <TableCell
                                      sx={{
                                          textAlign: "center",
                                          borderInlineEnd: "1px solid #3F78E0",
                                          color: "#333333",
                                      }}
                                  >
                                      {row.status_payment}
                                  </TableCell>
                                  <TableCell
                                      sx={{
                                          textAlign: "center",
                                          borderInlineEnd: "1px solid #3F78E0",
                                          color: "#333333",
                                      }}
                                  >
                                      ${row.price}
                                  </TableCell>
                                  <TableCell
                                      sx={{
                                          textAlign: "center",
                                          color: "#333333",
                                          display: "flex",
                                          flexDirection: "row",
                                          justifyContent: "center",
                                          alignItems: "center",
                                          gap: "10px",
                                      }}
                                  >

                                      {row.status_payment === "pending" &&
                                      (
                                          <Button
                                              sx={{
                                                  backgroundColor: "#3F78E0",
                                                  color: "#fff",
                                                  boxShadow: `
                          0px 3px 3px #00000040, 
                          inset 0px 4px 7px #FFFFFF40
                        `,
                                                  borderRadius: "6px",
                                                  width: "85px",
                                                  fontSize: "12px",
                                              }}
                                              onClick={() => {
                                                  navigate(
                                                      `/DomainInvoice?invoice_id=${row.uuid}`
                                                  );
                                              }}
                                          >
                                              Pay
                                          </Button>
                                      )}
                                  </TableCell>
                              </TableRow>
                          ))}
                      </TableBody>
                  </Table>
                  <div className="mt-4 flex justify-center items-center">
                      <TablePagination
                          page={currentPage}
                          className="mt-auto"
                          onPageChange={handlePageChange}
                          count={data.pagination.total}
                          rowsPerPage={rowsPerPage}
                          onRowsPerPageChange={handleChangeRowsPerPage}
                          variant="outlined"
                          shape="rounded"
                          rowsPerPageOptions={[ 25, 50,100]}
                      />
                  </div>
              </>
          ) : (
            <Table>
              <TableHead>
                <TableRow sx={{ backgroundColor: "#D1DDE4" }}>
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      color: "#333333",
                      textAlign: "center",
                      border: "1px solid #3F78E0",
                    }}
                  >
                    There are no data yet
                  </TableCell>
                </TableRow>
              </TableHead>
            </Table>
          )}
        </TableContainer>
      </Box>
    </>
  );
};

export default OrderHistory;
